var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9582 2.04175H12.4582V1.54175H11.9582V2.04175ZM11.9582 11.9584V12.4584H12.4582V11.9584H11.9582ZM2.0415 11.9584H1.5415V12.4584H2.0415V11.9584ZM2.0415 2.04175V1.54175H1.5415V2.04175H2.0415ZM6.49984 11.9584V12.4584H7.49984V11.9584H6.49984ZM11.9582 6.04175H12.4582V5.04175H11.9582V6.04175ZM2.0415 5.04175H1.5415V6.04175H2.0415V5.04175ZM11.4582 2.04175V11.9584H12.4582V2.04175H11.4582ZM11.9582 11.4584H2.0415V12.4584H11.9582V11.4584ZM2.5415 11.9584V2.04175H1.5415V11.9584H2.5415ZM2.0415 2.54175H11.9582V1.54175H2.0415V2.54175ZM7.49984 11.9584V5.54175H6.49984V11.9584H7.49984ZM6.99984 6.04175H11.9582V5.04175H6.99984V6.04175ZM6.99984 5.04175H2.0415V6.04175H6.99984V5.04175Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.99f425796b391f4b2c14d1a2cf0d31ee.svg";
export { ForwardRef as ReactComponent };